
import { Block } from 'baseui/block';
import { Heading, HeadingLevel } from 'baseui/heading';
import {
    ParagraphSmall,
} from 'baseui/typography';
import { Card, StyledBody } from 'baseui/card';

export type CardWithHeaderProps = {
    header?: string | null;
    subHeader?: string | null;
    children: any;
}



export const CardWithHeader = (props: CardWithHeaderProps) => {
    return (
        <Card>
            <HeadingLevel>
                <Heading styleLevel={6}>{props.header}</Heading>
                {props.subHeader! && <ParagraphSmall>{props.subHeader}</ParagraphSmall>}
            </HeadingLevel>
            <Block display='flex' flexDirection='column' >
                {props.children}
            </Block>
        </Card>
    )
}